import { DestroyRef, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { AppStoreFacade } from '../../store/app-store/app-store.facade';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class NavigationCleanupService {
  constructor(
    private router: Router,
    private appStoreFacade: AppStoreFacade,
    private destroyRef: DestroyRef,
  ) {}

  setupSearchIdCleanup(): void {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((event: NavigationEnd) => {
        const url = event.url;
        const isSearchResult = url.startsWith('/search');
        const isOffers = url.startsWith('/offers/');

        if (!isSearchResult && !isOffers) {
          this.appStoreFacade.setSearchId(null);
          this.appStoreFacade.setPreserveSearchId(false);
        }
      });
  }
}
